/*
 * wrap-superscript.js  (WEBD-1151)
 *
 * Global safety-net for the Liquid snippet `wrap-superscript.liquid`.
 *
 * Walks text nodes once after DOMContentLoaded and replaces Unicode
 * superscript characters (¹ ² ³ ⁴ ⁵ ⁶ ⁷ ⁸ ⁹ ⁰ ⁺ ⁻ and superscript
 * letters) with real <sup> tags so
 * the global CSS rule in custom-base.css can apply. This catches any
 * inline_richtext / metafield content that we didn't (or can't) route
 * through the Liquid snippet.
 *
 * - Read-mostly: only touches nodes that actually contain a superscript glyph
 * - Skips <script>, <style>, <sup>, <code>, <pre>, <textarea>, <noscript>
 * - Coalesces adjacent superscript chars ("¹²" -> <sup>12</sup>)
 * - No external deps, no jQuery, no impact on parser (loaded with `defer`)
 */
;(function () {
  if (typeof document === "undefined" || !document.createTreeWalker) return

  var SUP_MAP = {
    "⁰": "0",
    "¹": "1",
    "²": "2",
    "³": "3",
    "⁴": "4",
    "⁵": "5",
    "⁶": "6",
    "⁷": "7",
    "⁸": "8",
    "⁹": "9",
    "⁺": "+",
    "⁻": "-",
    ᵃ: "a",
    ᵇ: "b",
    ᶜ: "c",
    ᵈ: "d",
    ᵉ: "e",
    ᶠ: "f",
    ᵍ: "g",
    ʰ: "h",
    ⁱ: "i",
    ʲ: "j",
    ᵏ: "k",
    ˡ: "l",
    ᵐ: "m",
    ⁿ: "n",
    ᵒ: "o",
    ᵖ: "p",
    ʳ: "r",
    ˢ: "s",
    ᵗ: "t",
    ᵘ: "u",
    ᵛ: "v",
    ʷ: "w",
    ˣ: "x",
    ʸ: "y",
    ᶻ: "z",
    ᴬ: "A",
    ᴮ: "B",
    ᴰ: "D",
    ᴱ: "E",
    ᴳ: "G",
    ᴴ: "H",
    ᴵ: "I",
    ᴶ: "J",
    ᴷ: "K",
    ᴸ: "L",
    ᴹ: "M",
    ᴺ: "N",
    ᴼ: "O",
    ᴾ: "P",
    ᴿ: "R",
    ᵀ: "T",
    ᵁ: "U",
    ⱽ: "V",
    ᵂ: "W",
  }
  var SUP_RE = new RegExp(
    "[" +
      Object.keys(SUP_MAP)
        .join("")
        .replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&") +
      "]+",
    "g",
  )
  var SKIP_TAGS = {
    SCRIPT: 1,
    STYLE: 1,
    SUP: 1,
    CODE: 1,
    PRE: 1,
    TEXTAREA: 1,
    NOSCRIPT: 1,
    SVG: 1,
  }

  function shouldSkip(parent) {
    while (parent && parent.nodeType === 1) {
      if (SKIP_TAGS[parent.nodeName]) return true
      parent = parent.parentNode
    }
    return false
  }

  function wrap(root) {
    if (!root) return
    var walker = document.createTreeWalker(
      root,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode: function (node) {
          if (!node.nodeValue) return NodeFilter.FILTER_REJECT
          SUP_RE.lastIndex = 0
          if (!SUP_RE.test(node.nodeValue)) return NodeFilter.FILTER_REJECT
          if (shouldSkip(node.parentNode)) return NodeFilter.FILTER_REJECT
          return NodeFilter.FILTER_ACCEPT
        },
      },
      false,
    )

    var targets = []
    while (walker.nextNode()) targets.push(walker.currentNode)

    for (var i = 0; i < targets.length; i++) {
      var node = targets[i]
      var text = node.nodeValue
      var frag = document.createDocumentFragment()
      var lastIndex = 0
      SUP_RE.lastIndex = 0
      var m
      while ((m = SUP_RE.exec(text)) !== null) {
        if (m.index > lastIndex) {
          frag.appendChild(
            document.createTextNode(text.slice(lastIndex, m.index)),
          )
        }
        var sup = document.createElement("sup")
        var digits = ""
        for (var j = 0; j < m[0].length; j++) {
          digits += SUP_MAP[m[0].charAt(j)] || m[0].charAt(j)
        }
        sup.textContent = digits
        frag.appendChild(sup)
        lastIndex = m.index + m[0].length
      }
      if (lastIndex < text.length) {
        frag.appendChild(document.createTextNode(text.slice(lastIndex)))
      }
      node.parentNode.replaceChild(frag, node)
    }
  }

  function run() {
    wrap(document.body)
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run, { once: true })
  } else {
    run()
  }
})()
